<template>
  <section class="content">
    <table class="table table-hover" ref="tableuser">
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Username</th>
          <th>Email</th>
          <th>Group</th>
        </tr>
      </thead>
      <tbody>
      </tbody>
    </table>
  </section>
    <!-- /.content -->
</template>

<script>

import {createTable} from '@/libs/hxcore';

export default {
  name: 'Table',
  mounted() {
    const e = this.$refs;
    createTable(e.tableuser,
    {
      "title": "Tabel User",
      "ajax": "/examples/user_data",
      "columns": [
        { "data": "id" },
        { "data": "display_name" },
        { "data": "username" },
        { "data": "email" },
        { "data": "role_name" },
      ]
    });
  }
}

</script>
